function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.21825 1.00764C5.38435 0.841536 5.38435 0.572221 5.21825 0.406112C5.05214 0.240004 4.78282 0.240004 4.61671 0.406112L0.405988 4.61684C0.23988 4.78295 0.23988 5.05226 0.405989 5.21837C0.572097 5.38448 0.841412 5.38448 1.00752 5.21837L5.21825 1.00764Z",
  fill: "#707274"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.21814 4.61682L3.11278 2.51146C2.94667 2.34535 2.67735 2.34535 2.51125 2.51146L2.51125 2.51146C2.34514 2.67757 2.34514 2.94688 2.51125 3.11299L4.61661 5.21836C4.78272 5.38447 5.05203 5.38446 5.21814 5.21836C5.38425 5.05225 5.38425 4.78293 5.21814 4.61682Z",
  fill: "#707274"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M3.00132 2.40012L1.00731 0.406112C0.8412 0.240004 0.571885 0.240004 0.405777 0.406112C0.239669 0.572221 0.239669 0.841535 0.405777 1.00764L2.39979 3.00165C2.5659 3.16776 2.83521 3.16776 3.00132 3.00165C3.16743 2.83555 3.16743 2.56623 3.00132 2.40012Z",
  fill: "#707274"
});

function SvgCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.d25e1fc0.svg";
export { ForwardRef as ReactComponent };